const indexItems = [
  { label: '热血', icon: 'ri-fire-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { label: '恋爱', icon: 'ri-heart-line', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '奇幻', icon: 'ri-magic-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { label: '悬疑', icon: 'ri-search-eye-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
  { label: '搞笑', icon: 'ri-emotion-happy-line', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '科幻', icon: 'ri-rocket-line', color: 'text-secondary-500', bg: 'bg-secondary-50' },
  { label: '都市', icon: 'ri-building-line', color: 'text-primary-500', bg: 'bg-primary-100/50' },
  { label: '古风', icon: 'ri-landscape-line', color: 'text-accent-500', bg: 'bg-accent-100/50' },
  { label: '冒险', icon: 'ri-compass-line', color: 'text-secondary-500', bg: 'bg-secondary-100/50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">漫画分类</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">全品类漫画大全，总有一款适合你的口味</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl ${item.bg} hover:scale-105 transition-transform duration-200 cursor-pointer`}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                <i className={`${item.icon} ${item.color} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}